module.exports = __webpack_public_path__ + "static/media/Krombacher-SerifDemiItalic.ee103552.woff2";